










































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDevicePinedMessage from '@/components/builder/BuilderDevicePinedMessage.vue'
import BuilderDeviceChatsPreviewMessageStub from '@/components/builder/BuilderDeviceChatsPreviewMessageStub.vue'
import BuilderDevicePreviewMessageSecondStub from '@/components/builder/BuilderDevicePreviewMessageSecondStub.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderDeviceChatPreviewHeader from '@/components/builder/BuilderDeviceChatPreviewHeader.vue'
import BuilderDevicePreviewFooter from '@/components/builder/BuilderDevicePreviewFooter.vue'

@Component({
  components: {
    BuilderDevicePreviewFooter,
    BuilderDeviceChatPreviewHeader,
    BuilderDevice,
    BuilderDevicePreviewMessageSecondStub,
    BuilderDeviceChatsPreviewMessageStub,
    BuilderDevicePinedMessage,
  },
})
export default class BuilderDeviceChatsPreviewSecondStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: false, type: Boolean }) viewMode!: boolean
}
